import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import './BillingDetails.css'

const BillingDetails = () => {
  const { userId } = useParams()
  const navigate = useNavigate()

  // Static data for invoices - in a real app, this would be fetched based on userId
  const invoices = [
    { id: 1, invoiceNumber: '000012', date: '5/27/15', plan: 'Pro', amount: '$49.00', status: 'Paid' },
    { id: 2, invoiceNumber: 'Sep Invoice', date: '5/19/12', plan: 'Pro', amount: '$49.00', status: 'Overdue' },
    { id: 3, invoiceNumber: 'Sep Invoice', date: '3/4/16', plan: 'Pro', amount: '$49.00', status: 'Paid' },
    { id: 4, invoiceNumber: 'Sep Invoice', date: '3/4/16', plan: 'Pro', amount: '$49.00', status: 'Pending' }
  ]

  // Static data for payment history
  const paymentHistory = [
    { id: 1, date: '5/27/15', amount: '$49.00', payment: '$49.00', paymentMethod: 'Credit Card' },
    { id: 2, date: '5/19/12', amount: '$49.00', payment: '$49.00', paymentMethod: 'Credit Card' },
    { id: 3, date: '3/4/16', amount: '$49.00', payment: '$49.00', paymentMethod: 'Credit Card' },
    { id: 4, date: '3/4/16', amount: '$49.00', payment: '$49.00', paymentMethod: 'Credit Card' }
  ]

  const getInvoiceStatusBadgeClass = (status) => {
    switch (status.toLowerCase()) {
      case 'paid':
        return 'invoice-status-badge invoice-status-paid'
      case 'pending':
        return 'invoice-status-badge invoice-status-pending'
      case 'overdue':
        return 'invoice-status-badge invoice-status-overdue'
      default:
        return 'invoice-status-badge'
    }
  }

  return (
    <div className="billing-details-container">
      <div className="billing-details-header">
        <h1 className="page-title">Billing Details</h1>
        <button className="back-button" onClick={() => navigate('/billing-management')}>
          ← Back to Billing Management
        </button>
      </div>

      <div className="billing-sections">
        <div className="billing-section">
          <h2 className="section-title">Invoices</h2>
          <div className="table-card">
            <div className="table-wrapper">
              <table className="details-table">
                <thead>
                  <tr>
                    <th>Invoice #</th>
                    <th>Date</th>
                    <th>Plan</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {invoices.map((invoice) => (
                    <tr key={invoice.id}>
                      <td>{invoice.invoiceNumber}</td>
                      <td>{invoice.date}</td>
                      <td>{invoice.plan}</td>
                      <td>{invoice.amount}</td>
                      <td>
                        <span className={getInvoiceStatusBadgeClass(invoice.status)}>
                          {invoice.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="billing-section">
          <h2 className="section-title">Payment History</h2>
          <div className="table-card">
            <div className="table-wrapper">
              <table className="details-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Payment</th>
                    <th>Payment Method</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentHistory.map((payment) => (
                    <tr key={payment.id}>
                      <td>{payment.date}</td>
                      <td>{payment.amount}</td>
                      <td>{payment.payment}</td>
                      <td>{payment.paymentMethod}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BillingDetails









